import {
  checkType,
  CtyShowToast,
  getPalUrl,
  getPalSessionMode,
  injectPalChatbot,
  useScreenWidth,
  type SidebarItem,
  SidebarItemType,
} from '@circuitry-ai/doc-ui';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';

const SidebarItems = () => {
  const { t } = useTranslation();
  const width = useScreenWidth();
  const isMobile = width < 640;

  return [
    {
      key: 'dashboard',
      href: '/',
      icon: 'lucide:house',
      title: t('Dashboard'),
      show: true,
    },
    {
      key: 'journeys',
      href: '/aiworkers/list/journeys',
      icon: 'lucide:waypoints',
      title: t('Journeys'),
      show: true
    },
    {
      key: 'octr',
      title: t('AI Workers'),
      type: SidebarItemType.Nest,
      items: [
        {
          key: 'advisors',
          href: '/advisors',
          icon: 'bx:group',
          title: t('Advisors'),
          show: true,
        },
        {
          key: 'analyst',
          href: '/analytics',
          icon: 'keyline-icons:chart-no-axes-combined',
          title: t('Analysts'),
          show: true
        },
        {
          key: 'agents',
          href: '/agents',
          icon: 'lucide:bot',
          title: t('Agents'),
          show: true
        }
      ]
    },
    {
      key: 'agent',
      title: t('Sources'),
      type: SidebarItemType.Nest,
      items: [
        {
          key: 'knowledge',
          href: '/knowledge',
          icon: 'lucide:book-open',
          title: t('Knowledge'),
          show: true,
        },
        {
          key: 'actions',
          href: '/actions',
          icon: 'lucide:zap',
          title: t('Actions'),
          show: true,
        },
        {
          key: 'data',
          href: '/data',
          icon: 'lucide:database',
          title: t('Data'),
          show: true,
        }
      ]
    },
    {
      key: 'activity',
      title: t('Activity'),
      type: SidebarItemType.Nest,
      items: [
        {
          key: 'conversations',
          href: '/conversations',
          icon: 'lucide:message-square',
          title: t('Conversations'),
          show: true,
        },
        {
          key: 'history',
          href: '/history',
          icon: 'lucide:clock',
          title: t('History'),
          show: true
        },
        {
          key: 'triage',
          href: '/triage',
          icon: 'lucide:alert-circle',
          title: t('Triage'),
          show: true
        }
        // {
        //   key: 'conversationwithmilves',
        //   href: '/search-with-milvus',
        //   icon: 'ph:chat-text',
        //   title: t('Search With Milves'),
        // }
      ]
    },
    {
      key: 'sys',
      title: t('System'),
      type: SidebarItemType.Nest,
      items: [
        {
          key: 'help',
          // href: "/help",
          icon: 'lucide:circle-help',
          title: t('Support'),
        },
        {
          key: 'settings',
          href: '/settings',
          icon: 'lucide:settings',
          title: t('Settings'),
          show: true,
          endContent: (
            <Icon icon="lucide:chevron-right" width={16} height={16} className="shrink-0 text-[#71717a] dark:text-default-500" />
          ),
        }
      ],
    },
    {
      key: 'pal',
      title: t('Open PAL'),
      type: SidebarItemType.Nest,
      show: isMobile,
      items: [
        {
          key: 'New PAL Window',
          icon: 'fluent:window-new-20-regular',
          title: t('New PAL Window'),
          onClick: () => {
            const palUrl = getPalUrl();
            if (palUrl) {
              window.open(palUrl, '_blank', 'noopener,noreferrer');
            }
          },
        },
        {
          key: 'Widget',
          icon: 'heroicons:chat-bubble-left-right',
          title: t('Widget'),
          onClick: () => {
            injectPalChatbot(CtyShowToast, checkType, undefined, {
              open: true,
              resolveTargetMode: () => getPalSessionMode(),
            });
          },
        },
      ],
    },
  ] as SidebarItem[];
};

export default SidebarItems;
